import { render, staticRenderFns } from "./loginLubricator.vue?vue&type=template&id=8bd52c78&"
import script from "./loginLubricator.vue?vue&type=script&lang=js&"
export * from "./loginLubricator.vue?vue&type=script&lang=js&"
import style0 from "./loginLubricator.vue?vue&type=style&index=0&id=8bd52c78&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports